
import React from "react";
import Impressum from "@/components/Impressum";
import { Helmet } from "react-helmet";

const ImpressumPage = () => {
  return (
    <div className="min-h-screen bg-joerg-50">
      <Helmet>
        <title>Impressum | Jörg Hörmann Coaching & Consulting</title>
        <meta name="description" content="Impressum von Jörg Hörmann Coaching & Consulting. Hier finden Sie alle relevanten Kontaktdaten und rechtliche Informationen." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="pt-32">
        <Impressum />
      </div>
    </div>
  );
};

export default ImpressumPage;
